module.exports = __webpack_public_path__ + "static/logo-full-weiß-f778628cc4a0a9caf22425dd309d88e5.png";